"use client";

import { useHovercardDescription } from "../__chunks/I22EHHZ4.js";
import "../__chunks/343LYRPB.js";
import "../__chunks/GNXFPHGE.js";
import "../__chunks/RS7LB2H4.js";
import "../__chunks/S6EF7IVO.js";
import { createElement, createHook, forwardRef } from "../__chunks/LMDWO4NN.js";
import "../__chunks/ABQUS43J.js";
import "../__chunks/SK3NAZA3.js";
import "../__chunks/3YLGPPWQ.js";

// src/menu/menu-description.tsx
var TagName = "p";
var useMenuDescription = createHook(function useMenuDescription2(props) {
  props = useHovercardDescription(props);
  return props;
});
var MenuDescription = forwardRef(function MenuDescription2(props) {
  var htmlProps = useMenuDescription(props);
  return createElement(TagName, htmlProps);
});
export { MenuDescription, useMenuDescription };